import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import ListingTable from "../../../listing/listing";

export const UsersSlotForSixMonthList = ({ usersSlotForSixMonthListFetched }) => {
    const [usersSlotForSixMonthList, setUsersSlotForSixMonthList] = useState([]);
    const [listFetchSuccess, setListFetchSuccess] = useState(false);
    const [loaderFlag, setloaderFlag] = useState(true);

    const usersSlotForSixMonthListObj = {
        tableId: "usersSlotForSixMonthLists",
        tableTitle: "Users Appointment For Six Month List",
        showReload: true,
        showFilter: true,
        api: {
            url: process.env.REACT_APP_API_URL,
            endPoint: "calendarapi/users-slot-for-six-month-list",
            // deleteSingleUserEndpoint: "api/delete-user",
            tableCountEndpoint: "calendarapi/users-slot-for-six-month-list",
        },

        reqBody: {
            "condition": {
                "limit": 5,
                "skip": 0
            },
            "sort": {
                "field": "last_calendar_sync_time",
                "type": "desc"
            },
            "searchcondition": {
            },
            "count": false
        },
        deleteSingleUserReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },
        deleteMultipleReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },

        //******************************** By Default Rows per page option will be available**************************//

        rowsPerPageOptions: [5, 10, 20, 30],
        sortFields: ["createdTimeDifference", "last_calendar_sync_time", "start_date", "end_date"],
        paginationType: "stackPagination",
        enableRowActionLoader: true,
        customBtnHead: [
            // {
            //     id: "deleteMultiple",
            //     type: "delete_icon",
            //     title: "Delete",
            // },
            // {
            //     id: "editMultiple",
            //     type: "toggle_on_icon",
            //     title: "Status Change",
            // },
            // {
            //     id: "adduser",
            //     type: "add_icon",
            //     title: "ADD USER",
            //     className: "add_user_icon",
            //     default: true,
            // },
        ],
        buttons: [
        ],
        deleteModal: {
            modalClassName: "Delete Modal Deletemodal",
        },

        searchBarData: {
            heading: "Search Users Appointment For Six Month List",
            api: {
                url: process.env.REACT_APP_API_URL,
                endPoint: "calendarapi/users-slot-for-six-month-list",
                tableCountEndpoint: "calendarapi/users-slot-for-six-month-list",
                reqBody: {
                    // count:true,
                    // "source": "users",
                    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MzYzNTZkNDFjZTE3MzAwMDhiOGFhYTUiLCJzZWNyZXQiOiJ6R3RpMnY1enYiLCJpYXQiOjE2Njc5Njg3MzV9.wzFi1CoHbv9QK5cUHbVgSL6LW8m6fR_BaILcT7OcHBQ",
                    condition: {
                        limit: 5,
                        skip: 0,
                    },
                    sort: {
                        type: "desc",
                        field: "_id",
                    },
                },
            },

            searchSettings: {
                datesearch: [
                    {
                        id: 0,
                        heading: "Search By Last Calendar Sync",
                        startdatelabel: "Start Date",
                        enddatelabel: "End Date",
                        className: "formGroup createdon_datetime countDiv__column--col4",
                        submit: "Search",
                        field: "last_calendar_sync_time",
                    },
                ],
                selectsearch: [
                    // {
                    //     id: 1,
                    //     label: "Search By Status",
                    //     field: "status",
                    //     type: "select",
                    //     values: [0, 1],
                    //     // value: "",
                    // },


                ],
                textsearch: [
                    {
                        id: 1,
                        // heading: "Search By First Name",
                        label: "Search By Summary ",
                        field: "summary",
                        className: "formGroup summary countDiv__column--col4",
                        value: "",
                    },
                    {
                        id: 2,
                        // heading: "Search By First Name",
                        label: "Search By Connected Gmail ",
                        field: "connected_gmail",
                        className: "formGroup connected_gmail countDiv__column--col4",
                        value: "",
                    },
                ],

            },
        },
    };

    var modifyTableHeaders =
        [
            { val: "summary", name: "Summary" },
            { val: "connected_gmail", name: "Connected Gmail" },
            { val: "user_email", name: "User Email" },
            { val: "createdTimeDifference", name: "Created Time Difference" },
            // { val: "updatedTimeDifference", name: "Updated Time Difference" },
            { val: "allday", name: "Allday" },
            { val: "last_calendar_sync_time", name: "Last Calendar Sync", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },
            { val: "start_date", name: "Start Date", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },
            { val: "end_date", name: "End Date", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },

        ];

    const getList = async () => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(usersSlotForSixMonthListObj.reqBody),
        };
        const response = await fetch(
            process.env.REACT_APP_API_URL + "calendarapi/users-slot-for-six-month-list",
            requestOptions
        );
        const respdata = await response.json();
        console.log("++++cv+++++++", respdata);
        if (respdata && respdata.status === "success") {
            setUsersSlotForSixMonthList([...respdata.results.res])
        }
        setloaderFlag(false);
        usersSlotForSixMonthListFetched(true);
    }

    useEffect(() => {
        if (usersSlotForSixMonthList && usersSlotForSixMonthList.length === 0 && !listFetchSuccess) {
            setListFetchSuccess(true);
            getList()
        }

    }, [usersSlotForSixMonthList]);

    return (
        <>
            {loaderFlag == true ? (
                <Box sx={{ width: "100%", mt: "10px" }}>
                    <app-progressbar />
                </Box>
            ) : (
                ""
            )}

            <div className="reactTableWrapper miscList">

                {!loaderFlag && usersSlotForSixMonthList !== undefined ? (
                    <ListingTable
                        tableData={usersSlotForSixMonthListObj}
                        dataset={usersSlotForSixMonthList}
                        modifyHeaders={modifyTableHeaders}
                    />
                ) : ''}

            </div>
        </>
    )
}